import { IS_PRODUCTION } from 'interfaces/constants'

export type CarePathColorType =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'quaternary'

export type CarePathColorPattern = {
  [key in CarePathColorType]: string
}

export const CARE_PATH_DEFAULT_COLOR_PATTERN: CarePathColorPattern = {
  primary: '#FC7419',
  secondary: '#FEA21E',
  tertiary: '#009E5C',
  quaternary: '#00BEE0',
}

export const defaultTheme = [
  'blue.6',
  'indigol.9',
  'indigol.8',
  'yellow.7',
  'teal.4',
]

export const PAGE_USE_TYPE_FORM_TEMPLATE_LIST_STAGING = [
  {
    asPath:
      '/care-path/%e0%b8%a1%e0%b8%b0%e0%b9%80%e0%b8%a3%e0%b9%87%e0%b8%87%e0%b8%9b%e0%b8%b2%e0%b8%81%e0%b8%a1%e0%b8%94%e0%b8%a5%e0%b8%b9%e0%b8%81-hpv/',
    mobileFormId: 'o1b7cJVj',
    desktopFormId: 'KzNWVuD1',
  },
  {
    asPath:
      '/care-path/hpv-%e0%b8%84%e0%b8%b7%e0%b8%ad-%e0%b8%ad%e0%b8%b0%e0%b9%84%e0%b8%a3/',
    mobileFormId: 'o1b7cJVj',
    desktopFormId: 'KzNWVuD1',
  },
  {
    asPath: '/care-path/%e0%b9%80%e0%b8%8a%e0%b8%b7%e0%b9%89%e0%b8%ad-hpv/',
    mobileFormId: 'o1b7cJVj',
    desktopFormId: 'KzNWVuD1',
  },
  {
    asPath: '/care-path/langkah-pencegahan-kanser-serviks/',
    mobileFormId: 'o4ovYO5b',
    desktopFormId: 'utafYUqa',
  },
  {
    asPath: '/care-path/apa-itu-kanser-serviks/',
    mobileFormId: 'o4ovYO5b',
    desktopFormId: 'utafYUqa',
  },
  {
    asPath: '/carepath-demo-lead/do-tuoi-18-25/',
    mobileFormId: 'o4ovYO5b',
    desktopFormId: 'utafYUqa',
  },
  {
    asPath: '/carepath-demo/do-tuoi-18-25/',
    mobileFormId: 'o1b7cJVj',
    desktopFormId: 'KzNWVuD1',
  },
  {
    asPath: '/day-thi-som/',
    mobileFormId: 'V4EcdTaS',
    desktopFormId: 'V4EcdTaS',
  },
]

export const PAGE_USE_TYPE_FORM_TEMPLATE_LIST_PROD = [
  {
    asPath:
      '/care-path/%e0%b8%a1%e0%b8%b0%e0%b9%80%e0%b8%a3%e0%b9%87%e0%b8%87%e0%b8%9b%e0%b8%b2%e0%b8%81%e0%b8%a1%e0%b8%94%e0%b8%a5%e0%b8%b9%e0%b8%81-hpv/',
    mobileFormId: 'o1b7cJVj',
    desktopFormId: 'KzNWVuD1',
  },
  {
    asPath:
      '/care-path/hpv-%e0%b8%84%e0%b8%b7%e0%b8%ad-%e0%b8%ad%e0%b8%b0%e0%b9%84%e0%b8%a3/',
    mobileFormId: 'o1b7cJVj',
    desktopFormId: 'KzNWVuD1',
  },
  {
    asPath: '/care-path/%e0%b9%80%e0%b8%8a%e0%b8%b7%e0%b9%89%e0%b8%ad-hpv/',
    mobileFormId: 'o1b7cJVj',
    desktopFormId: 'KzNWVuD1',
  },
  {
    asPath: '/care-path/langkah-pencegahan-kanser-serviks/',
    mobileFormId: 'q6LD2BXv',
    desktopFormId: 'gBEy1dIY',
  },
  {
    asPath: '/care-path/apa-itu-kanser-serviks/',
    mobileFormId: 'q6LD2BXv',
    desktopFormId: 'gBEy1dIY',
  },
  {
    asPath: '/carepath-demo/do-tuoi-18-25/',
    mobileFormId: 'o1b7cJVj',
    desktopFormId: 'KzNWVuD1',
  },
  {
    asPath: '/carepath-demo/do-tuoi-26-35/',
    mobileFormId: 'q6LD2BXv',
    desktopFormId: 'gBEy1dIY',
  },
  {
    asPath: '/day-thi-som/',
    mobileFormId: 'T01ZTBUZ',
    desktopFormId: 'T01ZTBUZ',
  },
]

export const PAGE_USE_TYPE_FORM_TEMPLATE_LIST = IS_PRODUCTION
  ? PAGE_USE_TYPE_FORM_TEMPLATE_LIST_PROD
  : PAGE_USE_TYPE_FORM_TEMPLATE_LIST_STAGING
